import type { HookMap } from '@toast-ui/editor';
import { Loader } from '@mews-commander/ui';
import { uploadTaskImage } from '@mews-commander/legacy-entities/src/actions/tasks';
import { useCommanderSelector, useCommanderThunkDispatch } from '@mews-commander/utils';
import { useInvalidateRepositoryQuery } from '@mews-commander/data-access';
import TasksForm from '../components/TasksForm';
import {
    getCurrentDepartmentsOption,
    getTaskFormValues,
    isFetching as isFetchingSelector,
    getTaskFormattedMeta,
} from '../selectors';
import { updateTaskData } from '../actions/actions';

const EditForm = TasksForm({ updateTask: true });
interface Props {
    taskId: string;
    scope: string;
    form: string;
}
export const TasksEditForm = ({ taskId, scope, form }: Props) => {
    const departments = useCommanderSelector(getCurrentDepartmentsOption);
    const initialValues = useCommanderSelector((state) => getTaskFormValues(state, { taskId }));
    const taskMeta = useCommanderSelector((state) => getTaskFormattedMeta(state, { id: taskId, enterpriseId: scope }));
    const dispatch = useCommanderThunkDispatch();
    const invalidateQuery = useInvalidateRepositoryQuery();
    const onSubmit = async (values: $TSFixMe) => {
        // eslint-disable-next-line @typescript-eslint/await-thenable
        await dispatch(updateTaskData(values, taskId));
        await invalidateQuery('tasks', 'getAll');
    };
    const markdownEditorHooks: HookMap = {
        addImageBlobHook: async (blob, callback) => {
            const {
                value: { url },
            } = await dispatch(uploadTaskImage(blob, taskId));
            callback(url);
        },
    };
    const isFetching = useCommanderSelector(isFetchingSelector);
    if (isFetching) return <Loader />;
    return (
        <EditForm
            form={form}
            departments={departments}
            scope={scope}
            initialValues={initialValues}
            // @ts-expect-error
            taskMeta={taskMeta}
            onSubmit={onSubmit}
            markdownEditorHooks={markdownEditorHooks}
        />
    );
};
